const contactBt = {
	breadcrumbs: { home: 'ཁྱིམ་', contact: 'འབྲེལ་ལམ་' },
	hero: {
		title: 'ང་ཚོར་འབྲེལ་བ་འཐུས།',
		subtitle: 'ཁྱེད་ཀྱི་དྲི་བ་ བསམ་འཆར་ རམ་འདེགས་གང་རུང་ ང་ཚོ་ནང་ཡོད།'
	},
	quick: {
		title: 'མྱུར་དུ་རམ་འདེགས་ཐོབ།',
		actions: {
			liveChat: { title: 'དྲ་ཐོག་ཁ་སླབ་', desc: 'ད་ལྟ་རམ་འདེགས་ཐོབ།', cta: 'ཁ་སླབ་འགོ་འབུལ།' },
			helpCenter: { title: 'རོགས་རམ་ལྟེ་གནས་', desc: 'འགྲེལ་བཤད་མང་ཤོས་ཀྱི་ལན་', cta: 'རོགས་རམ་ལྟ།' },
			business: { title: 'ཚོང་འབྲེལ་ཞུ་བ་', desc: 'འབྲེལ་ལམ་དང་མཉམ་འབྲེལ་', cta: 'འབྲེལ་བ།' }
		}
	},
	info: {
		title: 'འབྲེལ་ལམ་གནས་ཚུལ་',
		service: { title: 'མི་དམངས་ཞབས་ཞུ་', desc: 'སྔ་དྲོ་ ༩ - དགོང་མཚམས་ ༩' },
		email: { title: 'ཨེ་མེལ', desc: '24 ཆུ་ཚོད་ནང་ལན་ལེན།' },
		address: {
			title: 'ཁ་བྱང་',
			desc: 'སྤྱི་གཙུག་དང་གཟའ་པ་སྣོན་ ༩-༦',
			primary: 'House #12, College Road,',
			secondary: 'Dukha Fakir Mor, Gurudaspur, Natore - 6440'
		}
	},
	form: {
		title: 'འཕྲིན་དོན་གཏང་།',
		desc: 'ཁྱེད་ཀྱི་གནས་ཚུལ་བྱིན་ནས་འཕྲིན་དོན་གཏང་། 24 ཆུ་ཚོད་ནང་འབྲེལ་བ་འབད།',
		name: 'མིང་',
		email: 'ཨེ་མེལ',
		phone: 'ཁ་པར་',
		subject: 'དོན་ཚན་',
		message: 'འཕྲིན་དོན་',
		messagePh: 'ཁྱེད་ཀྱི་དྲི་བ་ཡང་ན་བསམ་འཆར་གསལ་བཤད་བྱིན་...',
		submit: 'གཏང་།',
		success: 'ཁྱེད་ཀྱི་འཕྲིན་དོན་མཐར་འཁྱོལ་ཏེ་གཏང་ཡོད། དེ་མགྱོགས་སུ་འབྲེལ་བ་འབད་ནི་ཨིན།'
	},
	hours: {
		title: 'ཡིག་ཚང་དུས་ཚོད་',
		weekdays: 'སྤྱི་གཙུག - གཟའ་པ་སྣོན་',
		friday: 'གཟའ་ཕུར་བུ་',
		note: 'གཟའ་ཕུར་བུ་ཉིན་མི་དམངས་གོག་གནང་བས་ཞབས་ཞུ་འདོན་ལེན་ཚད་བཟོས་ཡོད།'
	},
	social: { title: 'སྤྱི་ཚོགས་འབྲེལ་ལམ་' },
	faq: {
		title: 'འཛོལ་བ་མང་ཤོས་ཀྱི་དྲི་བ་',
		subtitle: 'རོགས་རམ་དེབ་ནང་ལན་ཡོདཔ་འོང་།',
		cta: 'རོགས་རམ་ལྟེ་གནས་ལུ་འགྱོ།'
	}
};

export default contactBt;


